<script setup lang="ts">
import { Contact, Context } from '@/components/drawers/MemberDrawer/types/member-drawer.types'

defineProps<{
  contacts: Contact[]
}>()

const emit = defineEmits<{
  (e: 'start-call', phoneNumber: string): void;
  (e: 'copy-to-clipboard', payload: { context: Context, content: string }): void;
}>()
</script>

<template>
  <ul>
    <li v-for="contact in contacts" :key="`${$t(contact.label)}-contact`" class="mb-2">
      <h6 class="t3 text-context-4">{{ $t(contact.label) }}</h6>
      <div class="flex min-h-10 items-center justify-between">
        <div class="flex items-baseline gap-1">
          <p class="mb-0">{{ contact.content || "-" }}</p>

          <sword-icon
            v-if="!!contact.content && !!contact.warningMessage"
            v-tooltip="{ content: contact.warningMessage, align: 'center' }"
            name="warning"
          />
        </div>

        <div v-if="!!contact.content" class="flex">
          <sword-button-wuk
            v-if="contact.showCallButton"
            v-tooltip="$t('SIDEBAR.PHONE.START_CALL')"
            icon="phone"
            theme="transparent"
            round
            :aria-label="$t('SIDEBAR.PHONE.START_CALL')"
            @click.native="emit('start-call', contact.content)"
          />
          <sword-button-wuk
            v-tooltip="$t('COPY.CLIPBOARD')"
            icon="copy"
            theme="transparent"
            round
            :aria-label="`click to copy ${$t(contact.label)} to clipboard.`"
            @click.native="emit('copy-to-clipboard', {context: 'contact', content: contact.content})"
          />
        </div>
      </div>
    </li>
  </ul>
</template>
